import { FRAME_WIDTH, watermarkBox } from './frame';

/**
 * Watermark бесплатного тарифа.
 *
 * Первый реальный потребитель канала `session:config`: значение приходит с
 * сервера, а не вычисляется в клиенте. Это не педантизм - флаг в клиенте
 * снимался бы правкой одной строки в DevTools, а watermark входит в состав
 * бесплатного тира (docs/DECISIONS.md, F5).
 *
 * РАЗМЕЩЕНИЕ. Плашка стоит в НИЖНЕЙ ОХРАННОЙ ЗОНЕ TikTok и не участвует в
 * раскладке содержимого - геометрия в `@efira/game-sdk/frame`, там же выбор
 * зоны и его обоснование. Здесь - только отрисовка.
 */

export function Watermark() {
  /**
   * Положение берётся из одного места на весь продукт - `watermarkBox()`.
   *
   * Плашка стоит ВНУТРИ нижней охранной зоны TikTok и не участвует в раскладке
   * содержимого. Это решение владельца с принятой ценой: в охранной зоне метку
   * закрывает интерфейс TikTok, зритель её практически не видит, и watermark
   * теряет узнаваемость платформы и давление на переход к Pro. Взамен игра
   * получает всю безопасную область целиком.
   *
   * Обоснование выбора зоны и условия пересмотра - `docs/DECISIONS.md`, запись
   * [2026-09-17] «Watermark переносится в охранную зону».
   */
  const box = watermarkBox();

  return (
    <div
      className="overlay-watermark"
      style={{ top: `${box.top}px`, right: `${FRAME_WIDTH - box.right}px` }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 4167 4167" className="overlay-watermark__symbol" focusable="false">
        <path
          fill="#12b58c"
          d="M1094.564,2821.655c-0.006,-0.004 -644.531,362.064 -644.531,362.064l-241.699,-441.602l886.233,-493.546l-0.003,-1772.38l2087.402,1172.78l-1582.032,888.755l0.001,291.265l1846.18,-1042.647l512.218,296.991l-2863.77,1607.143l-0,-868.821Zm505.371,-854.531l571.289,-318.154l-571.289,-325.772l0,643.926Z"
        />
      </svg>
      efira.live
    </div>
  );
}
